import { render } from "./module.vue?vue&type=template&id=0d83f9b1&scoped=true"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import "./module.vue?vue&type=style&index=0&id=0d83f9b1&scoped=true&lang=css"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d83f9b1"]])

export default __exports__